export function Field({
  id,
  label,
  value,
  onChange,
  type = "text",
  required = false,
  min,
  step,
  inputMode,
  placeholder,
}) {
  return (
    <label className="form-field" htmlFor={id}>
      <span>
        {label}
        {required ? <b aria-hidden="true"> *</b> : null}
      </span>
      <input
        id={id}
        type={type}
        value={value}
        min={min}
        step={step}
        inputMode={inputMode}
        placeholder={placeholder}
        required={required}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  );
}

export function TextAreaField({
  id,
  label,
  value,
  onChange,
  required = false,
  rows = 3,
  placeholder,
}) {
  return (
    <label className="form-field form-field-wide" htmlFor={id}>
      <span>
        {label}
        {required ? <b aria-hidden="true"> *</b> : null}
      </span>
      <textarea
        id={id}
        rows={rows}
        value={value}
        placeholder={placeholder}
        required={required}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  );
}

export function SelectField({ id, label, value, onChange, options, required = false }) {
  return (
    <label className="form-field" htmlFor={id}>
      <span>
        {label}
        {required ? <b aria-hidden="true"> *</b> : null}
      </span>
      <select
        id={id}
        value={value}
        required={required}
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export function FormSection({ title, children }) {
  return (
    <section className="form-section">
      <h2>{title}</h2>
      <div className="form-grid">{children}</div>
    </section>
  );
}
